/* Check Your Health tools, second set (see sections/tool-plus.liquid). Renders the calculator named in [data-sk-tool2].
   Results appear when the visitor taps the button. Everything runs in the browser: nothing a visitor types is sent anywhere,
   and analytics events carry only the tool name and the kind of button tapped, never a value or a result.
   Educational estimates only; clinical thresholds are listed in each tool and need sign-off from the medical team. */
(function () {
  'use strict';

  /* ---------- small helpers ---------- */
  var tools = {};
  var WA = '919741681090';
  var LINKS = {
    consult: '/pages/book-consultation#book-consultation',
    capsules: '/products/sugar-knocker-single-bottle',
    berberine: '/products/berberine-advanced-500mg-dietary-supplement',
    tea: '/products/sugar-knocker-herbal-tea',
    kit: '/products/sugar-knocker-wellness-kit',
    idrs: '/pages/diabetes-risk-score',
    hba1c: '/pages/hba1c-calculator',
    converter: '/pages/blood-sugar-converter',
    waist: '/pages/waist-ratio-calculator',
    calorie: '/pages/calorie-and-carb-calculator',
    carb: '/pages/carb-counter',
    gi: '/pages/glycemic-index-lookup',
    checker: '/pages/blood-sugar-level-checker',
    homa: '/pages/homa-ir-calculator',
    hub: '/pages/diabetic-tools'
  };
  var DISCLAIMER = 'This tool is for education only. It is not a diagnosis or a treatment plan. Never stop or change a prescribed medicine without your doctor.';
  var PRIVACY = 'Nothing you enter is stored or sent anywhere.';

  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) ? n : NaN; }
  function round(n, d) { var p = Math.pow(10, d || 0); return Math.round(n * p) / p; }
  function q(sel, root) { return root.querySelector(sel); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function note(kind, title, text, extra) {
    return '<div class="tl-note tl-note--' + kind + (kind === 'alert' ? ' tl-note--urgent' : '') + '"' + (extra || '') + '><strong>' + title + '</strong>' + text + '</div>';
  }
  function urgent(text) { return note('alert', 'Please read this first', text, ' role="alert"'); }
  function stat(label, value, unit) {
    return '<div class="tl-stat"><div class="tl-stat__label">' + label + '</div><div class="tl-stat__value">' + value + (unit ? '<span class="tl-stat__unit">' + unit + '</span>' : '') + '</div></div>';
  }
  function stats(arr) { return '<div class="tl-stats">' + arr.join('') + '</div>'; }
  function list(items) { return '<ul class="tl-list">' + items.map(function (i) { return '<li>' + i + '</li>'; }).join('') + '</ul>'; }

  /* analytics: tool name and button kind only, never a value */
  function track(name, tool, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var e = { event: name, tool_name: tool };
      if (extra) for (var k in extra) e[k] = extra[k];
      window.dataLayer.push(e);
    } catch (err) { /* analytics must never break a tool */ }
  }

  /* number slider with a typeable value box and an inline error. extra: {min, max, step, def, optional}.
     The slider covers the usual range; the box also accepts a typed value outside it, which the hard range then checks. */
  function decimals(step) { return step < 1 ? (String(step).split('.')[1] || '').length : 0; }
  function nf(id, label, unit, hint, extra) {
    var x = extra || {}, min = x.min, max = x.max, step = x.step || 1, def = x.def != null ? x.def : min, opt = !!x.optional;
    return '<div class="tl-field t2-field tl-rng' + (opt ? ' t2-rng--unset' : '') + '" id="f-' + id + '" data-rng="' + id + '"' + (opt ? ' data-optional="1"' : '') + ' data-dec="' + decimals(step) + '">' +
      '<div class="tl-rng__top"><label for="' + id + '">' + label + (opt ? ' <span class="t2-calc">(optional)</span>' : '') + '</label>' +
      '<span class="tl-rng__val"><input type="text" inputmode="decimal" autocomplete="off" id="' + id + '" aria-describedby="e-' + id + '" value="' + (opt ? '' : def) + '" data-def="' + def + '"' + (opt ? ' placeholder="-"' : '') + '><b id="u-' + id + '">' + unit + '</b></span></div>' +
      '<input type="range" id="' + id + '-r" aria-label="' + label + ' slider" min="' + min + '" max="' + max + '" step="' + step + '" value="' + def + '" data-def="' + def + '">' +
      '<div class="tl-rng__ends"><span id="' + id + '-lo">' + min + '</span><span id="' + id + '-hi">' + max + '</span></div>' +
      (hint ? '<small>' + hint + '</small>' : '') + '<span class="t2-err" id="e-' + id + '" role="alert"></span></div>';
  }
  function paintRng(r) {
    var p = (num(r.value) - num(r.min)) / (num(r.max) - num(r.min)) * 100;
    r.style.setProperty('--p', Math.max(0, Math.min(100, p)) + '%');
  }
  /* keep slider and box in step (delegated, so fields added later work too) */
  function bindRngs(root) {
    root.addEventListener('input', function (e) {
      var t = e.target, wrap = t.closest && t.closest('[data-rng]'); if (!wrap) return;
      var id = wrap.getAttribute('data-rng'), box = q('#' + id, wrap), r = q('#' + id + '-r', wrap);
      if (t === r) {
        box.value = round(num(r.value), +wrap.getAttribute('data-dec')).toFixed(+wrap.getAttribute('data-dec'));
        wrap.classList.remove('t2-rng--unset'); wrap.classList.remove('t2-field--err'); q('#e-' + id, wrap).textContent = '';
      } else if (t === box) {
        var v = num(box.value);
        if (isFinite(v)) { r.value = Math.max(num(r.min), Math.min(num(r.max), v)); wrap.classList.remove('t2-rng--unset'); }
        else if (box.value.trim() === '') wrap.classList.add('t2-rng--unset');
      }
      paintRng(r);
    });
    /* tell listeners the value changed once the slider is released (not on every tick) */
    root.addEventListener('change', function (e) {
      var t = e.target, wrap = t.closest && t.closest('[data-rng]');
      if (wrap && t.type === 'range') q('#' + wrap.getAttribute('data-rng'), wrap).dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function paintAll(root) { [].forEach.call(root.querySelectorAll('input[type="range"]'), paintRng); }
  /* change a slider's range (unit switch, or a different field layout) and reset it to a default; optional fields go back to empty */
  function setRng(root, id, min, max, step, def) {
    var wrap = q('#f-' + id, root); if (!wrap) return;
    var r = q('#' + id + '-r', wrap), box = q('#' + id, wrap);
    r.min = min; r.max = max; r.step = step; r.value = def; r.setAttribute('data-def', def);
    wrap.setAttribute('data-dec', decimals(step));
    q('#' + id + '-lo', wrap).textContent = min; q('#' + id + '-hi', wrap).textContent = max;
    if (wrap.getAttribute('data-optional') === '1') { box.value = ''; wrap.classList.add('t2-rng--unset'); } else { box.value = Number(def).toFixed(decimals(step)); }
    box.setAttribute('data-def', def); wrap.classList.remove('t2-field--err'); q('#e-' + id, wrap).textContent = '';
    paintRng(r);
  }
  /* back to defaults after a form reset */
  function resetRngs(root) {
    [].forEach.call(root.querySelectorAll('[data-rng]'), function (wrap) {
      var id = wrap.getAttribute('data-rng'), r = q('#' + id + '-r', wrap), box = q('#' + id, wrap), d = r.getAttribute('data-def');
      var optional = wrap.getAttribute('data-optional') === '1';
      r.value = d; box.value = optional ? '' : Number(d).toFixed(+wrap.getAttribute('data-dec'));
      wrap.classList.toggle('t2-rng--unset', optional); paintRng(r);
    });
  }
  function fld(label, html, hint, id) {
    return '<div class="tl-field"' + (id ? ' id="' + id + '"' : '') + '><label>' + label + '</label>' + html + (hint ? '<small>' + hint + '</small>' : '') + '</div>';
  }
  function seg(id, opts, cur, cls) {
    return '<div class="' + (cls || 'tl-seg') + '" id="' + id + '" role="radiogroup">' + opts.map(function (o) {
      return '<button type="button" role="radio" data-v="' + o[0] + '" aria-checked="' + (o[0] === cur) + '">' + o[1] + '</button>';
    }).join('') + '</div>';
  }
  function bindSeg(root, id, cb) {
    var g = q('#' + id, root);
    g.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]'); if (!b) return;
      [].forEach.call(g.children, function (c) { c.setAttribute('aria-checked', c === b ? 'true' : 'false'); });
      if (cb) cb(b.getAttribute('data-v'));
    });
  }
  function sv(root, id) { var b = q('#' + id + ' [aria-checked="true"]', root); return b ? b.getAttribute('data-v') : ''; }

  /* read a number and check it against a hard range (reject) and a soft range (accept, ask to re-check).
     `fmt` formats the range in the message. Returns NaN when rejected. Soft warnings are pushed to ctx.soft. */
  function read(root, id, label, hardMin, hardMax, softMin, softMax, ctx, unitLabel, optional) {
    var el = q('#' + id, root), box = q('#f-' + id, root), err = q('#e-' + id, root), raw = el.value.trim();
    var v = num(raw), msg = '';
    if (raw === '') { if (optional) { box.classList.remove('t2-field--err'); err.textContent = ''; return NaN; } msg = 'Enter ' + label.toLowerCase() + '.'; }
    else if (!isFinite(v)) msg = 'Enter a number, for example ' + hardMin + '.';
    else if (v < hardMin || v > hardMax) msg = label + ' should be between ' + hardMin + ' and ' + hardMax + (unitLabel ? ' ' + unitLabel : '') + '.';
    box.classList.toggle('t2-field--err', !!msg);
    err.textContent = msg;
    if (msg) { ctx.bad = true; if (!ctx.first) ctx.first = el; return NaN; }
    if ((softMin != null && v < softMin) || (softMax != null && v > softMax)) ctx.soft.push(label.toLowerCase() + ' of ' + raw);
    return v;
  }
  function softNote(ctx) {
    return ctx.soft.length ? note('info', 'Please re-check this reading', 'Your ' + ctx.soft.join(' and ') + ' is unusual. We have used it, but check you typed it correctly and in the right unit.') : '';
  }

  /* horizontal scale: segs = [[widthWeight, cls, label]], value position given as 0..1 of the whole bar */
  function scale(segs, pos) {
    var tot = segs.reduce(function (a, s) { return a + s[0]; }, 0);
    return '<div class="t2-scale" aria-hidden="true"><div class="t2-scale__bar">' + segs.map(function (s) {
      return '<i class="' + s[1] + '" style="width:' + (s[0] / tot * 100) + '%"></i>';
    }).join('') + '<span class="t2-scale__pin" style="left:' + Math.max(1, Math.min(99, pos * 100)) + '%"></span></div>' +
      '<div class="t2-scale__lbl">' + segs.map(function (s) { return '<span style="width:' + (s[0] / tot * 100) + '%">' + s[2] + '</span>'; }).join('') + '</div></div>';
  }
  function posIn(v, lo, hi) { return (v - lo) / (hi - lo); }

  /* calls to action: [{k:'consult|product|kit|whatsapp|pdf', href, label, primary}] */
  function ctas(items, summary) {
    var h = items.map(function (c) {
      return '<a class="t2-btn' + (c.primary ? ' t2-btn--primary' : '') + '" href="' + c.href + '" data-t2-cta="' + c.k + '"' + (c.ext ? ' target="_blank" rel="noopener"' : '') + '>' + c.label + '</a>';
    });
    if (summary) h.push('<a class="t2-btn" data-t2-cta="whatsapp" target="_blank" rel="noopener" href="https://wa.me/' + WA + '?text=' + encodeURIComponent(summary) + '">Get this on WhatsApp</a>');
    return '<div class="t2-ctas">' + h.join('') + '</div>';
  }
  /* printed reports (PDF): Sugar Knocker logo header and footer, and a print that waits for the logo to load */
  function brand() {
    var host = document.querySelector('[data-sk-tool2]'), src = host && host.getAttribute('data-logo');
    return '<div class="t2-print__brand">' + (src ? '<img src="' + src + '" alt="Sugar Knocker" width="180">' : '<strong>Sugar Knocker</strong>') + '<span>knockdiabetes.com</span></div>';
  }
  function printReport(host, after) {
    document.body.classList.add('t2-printing'); host.style.display = 'block';
    var imgs = [].slice.call(host.querySelectorAll('img')), done = false;
    function go() {
      if (done) return; done = true;
      window.print();
      setTimeout(function () { document.body.classList.remove('t2-printing'); host.style.display = 'none'; if (after) after(); }, 300);
    }
    var pending = imgs.filter(function (i) { return !i.complete; });
    if (!pending.length) return go();
    var left = pending.length;
    pending.forEach(function (i) { i.addEventListener('load', function () { if (--left === 0) go(); }); i.addEventListener('error', function () { if (--left === 0) go(); }); });
    setTimeout(go, 2500);
  }
  function fine() { return '<p class="t2-fine">' + DISCLAIMER + ' ' + PRIVACY + '</p>'; }

  /* step form: each top-level field group becomes one step (a group of more than two fields is split in pairs), with a progress
     bar and Back / Next. The submit button shows on the last step. Returns null when there is only one step. */
  function buildSteps(form, onChange) {
    var actions = q('.t2-actions', form), kids = [].filter.call(form.children, function (c) { return c !== actions; }), steps = [];
    kids.forEach(function (k) {
      if (k.classList.contains('tl-grid2') && k.children.length > 2) {
        var items = [].slice.call(k.children);
        for (var i = 0; i < items.length; i += 2) {
          var g = document.createElement('div'); g.className = 'tl-grid2';
          g.appendChild(items[i]); if (items[i + 1]) g.appendChild(items[i + 1]);
          form.insertBefore(g, k); steps.push(g);
        }
        form.removeChild(k);
      } else steps.push(k);
    });
    if (steps.length < 2) return null;
    var prog = document.createElement('div');
    prog.className = 't2-prog';
    prog.innerHTML = '<div class="t2-prog__top"><span class="t2-prog__txt" aria-live="polite"></span></div><div class="t2-prog__bar" aria-hidden="true"><i></i></div>';
    form.insertBefore(prog, form.firstChild);
    var txt = q('.t2-prog__txt', prog), bar = q('.t2-prog__bar i', prog), go = q('.t2-go', form), reset = q('[data-t2-reset]', form);
    var back = document.createElement('button'); back.type = 'button'; back.className = 't2-btn t2-back'; back.textContent = 'Back';
    var next = document.createElement('button'); next.type = 'button'; next.className = 't2-go t2-next'; next.textContent = 'Next';
    actions.insertBefore(next, actions.firstChild); actions.insertBefore(back, actions.firstChild);
    var cur = 0, last = steps.length - 1;
    steps.forEach(function (s) { s.classList.add('t2-step'); });
    function show(i) {
      cur = Math.max(0, Math.min(last, i));
      steps.forEach(function (s, n) { s.classList.toggle('t2-step--off', n !== cur); });
      txt.textContent = 'Step ' + (cur + 1) + ' of ' + steps.length;
      bar.style.width = ((cur + 1) / steps.length * 100) + '%';
      back.hidden = cur === 0; next.hidden = cur === last; go.hidden = cur !== last;
      if (reset) reset.hidden = cur !== last;
      if (onChange) onChange();
    }
    /* a step is complete when each required number box holds a number (the hard ranges are checked when the result is requested) */
    function stepOk(s) {
      var ok = true;
      [].forEach.call(s.querySelectorAll('[data-rng]'), function (w) {
        if (w.getAttribute('data-optional') === '1') return;
        var id = w.getAttribute('data-rng'), raw = q('#' + id, w).value.trim(), msg = '';
        if (raw === '') msg = 'Enter a value to continue.'; else if (!isFinite(num(raw))) msg = 'Enter a number, for example ' + q('#' + id + '-r', w).value + '.';
        w.classList.toggle('t2-field--err', !!msg); q('#e-' + id, w).textContent = msg;
        if (msg) ok = false;
      });
      return ok;
    }
    next.addEventListener('click', function () { if (stepOk(steps[cur])) show(cur + 1); });
    back.addEventListener('click', function () { show(cur - 1); });
    show(0);
    return {
      show: show, next: next,
      cur: function () { return cur; }, last: last,
      indexOf: function (el) { for (var n = 0; n < steps.length; n++) if (steps[n].contains(el)) return n; return -1; }
    };
  }

  /* shared form frame. `fields` html, `calc(ctx)` returns result html (or null when validation failed).
     opts.steps === false keeps every field on one screen. */
  function frame(root, name, fields, opts) {
    opts = opts || {};
    root.innerHTML = '<form class="t2-form" novalidate>' + fields +
      '<div class="t2-actions"><button type="submit" class="t2-go">' + (opts.go || 'Check') + '</button>' +
      (opts.reset !== false ? '<button type="button" class="t2-btn" data-t2-reset>Start again</button>' : '') + '</div></form>' +
      '<div class="t2-result" aria-live="polite"></div><p class="t2-priv">' + PRIVACY + '</p>';
    var form = q('form', root), out = q('.t2-result', root), started = false;
    var stepper = opts.steps === false ? null : buildSteps(form, function () { out.innerHTML = ''; });
    bindRngs(form); paintAll(form);
    function start() { if (!started) { started = true; track('tool_start', name); } }
    form.addEventListener('input', start);
    /* every radio-style button group in the form selects on tap (the groups are plain buttons with aria-checked) */
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[role="radiogroup"] button[data-v]'); if (!b) return;
      start();
      [].forEach.call(b.parentNode.children, function (c) { c.setAttribute('aria-checked', c === b ? 'true' : 'false'); });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (stepper && stepper.cur() < stepper.last) { stepper.next.click(); return; } // Enter inside a field moves on, it does not submit
      var ctx = { soft: [], bad: false, first: null };
      var html = opts.calc(ctx);
      if (ctx.bad || html == null) {
        out.innerHTML = '';
        if (stepper && ctx.first) { var n = stepper.indexOf(ctx.first); if (n > -1) stepper.show(n); }
        if (ctx.first) ctx.first.focus();
        return;
      }
      out.innerHTML = html + softNote(ctx) + fine();
      track('tool_complete', name);
      if (out.scrollIntoView) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    q('[data-t2-reset]', root) && q('[data-t2-reset]', root).addEventListener('click', function () {
      form.reset(); resetRngs(root);
      [].forEach.call(root.querySelectorAll('.t2-field--err'), function (b) { b.classList.remove('t2-field--err'); });
      [].forEach.call(root.querySelectorAll('.t2-err'), function (b) { b.textContent = ''; });
      if (opts.onReset) opts.onReset();
      out.innerHTML = '';
      if (stepper) stepper.show(0);
    });
    return { form: form, out: out, stepper: stepper };
  }

  /* unit toggle: switches the unit label and the slider range. ranges: {mg: [min, max, step, def], mmol: [...]}.
     The number typed or slid is read in the unit selected when the visitor taps the button. */
  function unitToggle(root, segId, fields, labels) {
    bindSeg(root, segId, function (v) {
      Object.keys(fields).forEach(function (id) {
        var r = fields[id][v];
        q('#u-' + id, root).textContent = labels[v];
        setRng(root, id, r[0], r[1], r[2], r[3]);
      });
    });
  }

  /* =========================================================
     Tool 1. Blood sugar reading checker
     ========================================================= */
  tools.sugarcheck = function (root) {
    var r = frame(root, 'sugarcheck',
      '<div class="tl-grid2">' + nf('rd', 'Your reading', 'mg/dL', 'Slide, or type the number from your meter or lab report', { min: 20, max: 600, step: 1, def: 100 }) +
      fld('Unit', seg('unit', [['mg', 'mg/dL'], ['mmol', 'mmol/L']], 'mg')) + '</div>' +
      fld('Type of test', seg('test', [['fasting', 'Fasting (8+ hours, no food)'], ['ppbs', '2 hours after a meal (PPBS)'], ['random', 'Random']], 'fasting', 'tl-ropts')) +
      fld('Diagnosed with diabetes?', seg('diag', [['no', 'No'], ['yes', 'Yes'], ['unsure', 'Not sure']], 'no')),
      {
        go: 'Check my reading',
        calc: function (ctx) {
          var unit = sv(root, 'unit'), test = sv(root, 'test'), diag = sv(root, 'diag');
          var raw = num(q('#rd', root).value), mg;
          // the hard and soft ranges are written in mg/dL; mmol/L entries are tested at their mg/dL equivalent
          var v = unit === 'mmol'
            ? read(root, 'rd', 'Reading', 1.1, 33.3, 2.2, 25, ctx, 'mmol/L')
            : read(root, 'rd', 'Reading', 20, 600, 40, 450, ctx, 'mg/dL');
          if (ctx.bad) return null;
          mg = unit === 'mmol' ? v * 18.016 : v;
          var mmol = unit === 'mmol' ? v : v / 18.016;
          var known = diag === 'yes', name, kind, text, ranges, pos;
          var testName = { fasting: 'fasting', ppbs: '2 hours after a meal', random: 'random' }[test];
          var banners = '', noProduct = false;

          if (mg < 54 || (mg < 70 && known)) {
            banners += urgent('This reading is low. Take 15 g of fast sugar (for example 3 teaspoons of sugar in water) and recheck in 15 minutes. If you feel confused or faint, get medical help now.');
            noProduct = true;
          }
          if (mg >= 300) {
            banners += urgent('This reading is very high. Contact your doctor today; seek emergency care if you have vomiting, heavy breathing or drowsiness.');
            noProduct = true;
          }

          if (known) {
            var hi = test === 'fasting' ? 130 : 180;
            if (mg < 70) { name = 'Low'; kind = 'alert'; text = 'A reading under 70 mg/dL is low blood sugar.'; noProduct = true; }
            else if (test === 'fasting' && mg < 80) { name = 'Below the usual target'; kind = 'warn'; text = 'A fasting reading under 80 mg/dL is lower than the usual target of 80 to 130 mg/dL. Your doctor sets your personal target.'; }
            else if ((test === 'fasting' && mg <= 130) || (test !== 'fasting' && mg < 180)) { name = 'In the usual target'; kind = 'good'; text = (test === 'fasting' ? 'A fasting reading of 80 to 130 mg/dL' : 'A reading under 180 mg/dL after a meal') + ' is within the target many doctors use for people with diabetes. Your doctor sets your personal target.'; }
            else { name = 'Above the usual target'; kind = 'warn'; text = 'This is above the target many doctors use for people with diabetes (' + (test === 'fasting' ? 'fasting 80 to 130' : 'under 180 after a meal') + ' mg/dL). A single reading does not change your plan; note it and share it with your doctor.'; }
            ranges = test === 'fasting'
              ? [[70, 'c-low', 'Low'], [10, 'c-warn', '&lt;80'], [50, 'c-good', '80-130'], [90, 'c-alert', 'Above 130']]
              : [[70, 'c-low', 'Low'], [110, 'c-good', 'Under 180'], [220, 'c-alert', 'Above 180']];
            var lo0 = 20;
            pos = ranges.reduce(function (a, s) { return a + s[0]; }, 0);
            // position: map mg to the cumulative scale 20..max
            var edges = test === 'fasting' ? [20, 70, 80, 130, 330] : [20, 70, 180, 400];
            pos = bandPos(mg, edges, ranges);
          } else {
            if (test === 'fasting') {
              ranges = [[50, 'c-low', 'Low'], [30, 'c-good', 'Normal'], [26, 'c-warn', 'Prediabetes'], [100, 'c-alert', 'Diabetes']];
              pos = bandPos(mg, [20, 70, 100, 126, 226], ranges);
            } else {
              ranges = [[50, 'c-low', 'Low'], [70, 'c-good', 'Normal'], [60, 'c-warn', test === 'random' ? 'Higher' : 'Prediabetes'], [100, 'c-alert', 'Diabetes']];
              pos = bandPos(mg, [20, 70, 140, 200, 300], ranges);
            }
            if (mg < 70) { name = 'Low'; kind = 'alert'; text = 'A reading under 70 mg/dL is low. If you feel shaky, sweaty or dizzy, have some fast sugar and recheck.'; noProduct = true; }
            else if (test === 'fasting') {
              if (mg < 100) { name = 'Normal'; kind = 'good'; text = 'A fasting reading of 70 to 99 mg/dL is in the normal range.'; }
              else if (mg < 126) { name = 'Prediabetes range'; kind = 'warn'; text = 'A fasting reading of 100 to 125 mg/dL is the range doctors call prediabetes. Food, activity and sleep habits make a real difference here.'; }
              else { name = 'Diabetes range'; kind = 'alert'; text = 'A fasting reading of 126 mg/dL or more is in the diabetes range. One reading cannot diagnose diabetes. Ask your doctor for a repeat fasting test or an HbA1c.'; }
              ranges = [[50, 'c-low', 'Low'], [30, 'c-good', 'Normal'], [26, 'c-warn', 'Prediabetes'], [100, 'c-alert', 'Diabetes']];
              pos = bandPos(mg, [20, 70, 100, 126, 226], ranges);
            } else {
              var label = test === 'random' ? 'higher than usual' : 'Prediabetes range';
              if (mg < 140) { name = 'Normal'; kind = 'good'; text = 'A reading under 140 mg/dL ' + (test === 'ppbs' ? 'two hours after a meal ' : '') + 'is in the normal range.'; }
              else if (mg < 200) { name = test === 'random' ? 'Higher than usual' : 'Prediabetes range'; kind = 'warn'; text = 'A reading of 140 to 199 mg/dL ' + (test === 'ppbs' ? 'two hours after a meal ' : '') + 'is ' + (test === 'random' ? 'higher than usual. Check a fasting reading next.' : 'the range doctors call prediabetes.'); }
              else { name = 'Diabetes range'; kind = 'alert'; text = 'A reading of 200 mg/dL or more is in the diabetes range. One reading cannot diagnose diabetes. Ask your doctor for a repeat fasting test or an HbA1c.'; }
              ranges = [[50, 'c-low', 'Low'], [70, 'c-good', 'Normal'], [60, 'c-warn', test === 'random' ? 'Higher' : 'Prediabetes'], [100, 'c-alert', 'Diabetes']];
              pos = bandPos(mg, [20, 70, 140, 200, 300], ranges);
            }
          }
          var summary = 'My ' + testName + ' blood sugar reading: ' + round(mg, 0) + ' mg/dL (' + round(mmol, 1) + ' mmol/L), shown as "' + name + '" on the Sugar Knocker checker.';
          var cta;
          if (noProduct || name === 'Low') cta = '';
          else if (name === 'Normal') cta = ctas([{ k: 'idrs', href: LINKS.idrs, label: 'Check your diabetes risk (IDRS)', primary: true }], summary);
          else if (name === 'In the usual target') cta = ctas([{ k: 'consult', href: LINKS.consult, label: 'Book a free 30-minute consultation', primary: true }], summary);
          else if (name === 'Prediabetes range' || name === 'Higher than usual') cta = ctas([{ k: 'product', href: LINKS.capsules, label: 'See how a plant-based routine fits', primary: true }, { k: 'consult', href: LINKS.consult, label: 'Free consultation' }], summary);
          else cta = ctas([{ k: 'consult', href: LINKS.consult, label: 'Book a free 30-minute consultation', primary: true }, { k: 'product', href: LINKS.capsules, label: 'Explore Sugar Knocker' }], summary);

          return banners +
            '<p class="t2-range">' + name + '<small>' + round(mg, 0) + ' mg/dL &middot; ' + round(mmol, 1) + ' mmol/L &middot; ' + testName + '</small></p>' +
            scale(ranges, pos) +
            note(kind, name, text) +
            '<p class="t2-fine">Related: <a href="' + LINKS.hba1c + '">HbA1c calculator</a> &middot; <a href="' + LINKS.converter + '">Blood sugar converter</a></p>' + cta;
        }
      });
    unitToggle(root, 'unit', { rd: { mg: [20, 600, 1, 100], mmol: [1.1, 33.3, 0.1, 5.6] } }, { mg: 'mg/dL', mmol: 'mmol/L' });
  };
  /* position of a value (0..1) on a bar made of bands with the given edge values */
  function bandPos(v, edges, segs) {
    var tot = segs.reduce(function (a, s) { return a + s[0]; }, 0), acc = 0;
    for (var i = 0; i < segs.length; i++) {
      var lo = edges[i], hi = edges[i + 1];
      if (v < hi || i === segs.length - 1) {
        var f = Math.max(0, Math.min(1, (v - lo) / (hi - lo)));
        return (acc + segs[i][0] * f) / tot;
      }
      acc += segs[i][0];
    }
    return 1;
  }

  /* =========================================================
     Tool 6. HOMA-IR
     ========================================================= */
  tools.homair = function (root) {
    frame(root, 'homair',
      '<div class="tl-grid2">' + nf('ins', 'Fasting insulin', 'µIU/mL', 'From the same blood test as the glucose', { min: 0.5, max: 60, step: 0.5, def: 10 }) +
      nf('glu', 'Fasting glucose', 'mg/dL', 'Same sample as the insulin', { min: 40, max: 400, step: 1, def: 95 }) + '</div>' +
      fld('Glucose unit', seg('unit', [['mg', 'mg/dL'], ['mmol', 'mmol/L']], 'mg')) +
      fld('Do you inject insulin?', seg('inj', [['no', 'No'], ['yes', 'Yes']], 'no')),
      {
        go: 'Calculate HOMA-IR',
        calc: function (ctx) {
          var unit = sv(root, 'unit'), inj = sv(root, 'inj');
          var ins = read(root, 'ins', 'Fasting insulin', 0.5, 300, 2, 60, ctx, 'µIU/mL');
          var glu = unit === 'mmol' ? read(root, 'glu', 'Fasting glucose', 2.2, 22.2, 3, 15, ctx, 'mmol/L') : read(root, 'glu', 'Fasting glucose', 40, 400, 60, 250, ctx, 'mg/dL');
          if (ctx.bad) return null;
          var consult = { k: 'consult', href: LINKS.consult, label: 'Discuss your insulin result with our medical team', primary: true };
          if (inj === 'yes') {
            return note('warn', 'No score for people who inject insulin', 'HOMA-IR is not valid for people who inject insulin, because the insulin in your blood test is not only your own. Please ask your doctor how to read your insulin result.') + ctas([consult]);
          }
          var mgdl = unit === 'mmol' ? glu * 18.016 : glu;
          var homa = unit === 'mmol' ? ins * glu / 22.5 : ins * glu / 405;
          homa = round(homa, 2);
          var name, kind, text;
          if (homa < 2.0) { name = 'In the usual range'; kind = 'good'; text = 'Your score may suggest your body responds to insulin in the usual way.'; }
          else if (homa < 3.0) { name = 'Some insulin resistance is likely'; kind = 'warn'; text = 'Your score may suggest some insulin resistance. Activity after meals, a healthy waist and good sleep all help insulin work better.'; }
          else { name = 'Marked insulin resistance is likely'; kind = 'alert'; text = 'Your score may suggest marked insulin resistance. Please discuss it with your doctor, who can look at it alongside your other results.'; }
          var extra = mgdl >= 126 ? note('warn', 'Fasting glucose in the diabetes range', 'A fasting glucose of 126 mg/dL or more is in the diabetes range. One reading cannot diagnose diabetes. Ask your doctor for a repeat fasting test or an HbA1c.') : '';
          var c = [consult];
          if (homa >= 2.0) c.push({ k: 'product', href: LINKS.berberine, label: 'Explore a focused berberine routine' });
          var berb = homa >= 2.0 ? '<p class="t2-fine">Berberine may interact with prescription medicines. Check with your doctor before using it.</p>' : '';
          return '<p class="t2-range">HOMA-IR ' + homa.toFixed(2) + '<small>' + name + '</small></p>' +
            scale([[20, 'c-good', 'Under 2.0'], [10, 'c-warn', '2.0-2.9'], [20, 'c-alert', '3.0 and above']], bandPos(homa, [0, 2, 3, 6], [[20], [10], [20]])) +
            note(kind, name, text) + extra +
            list(['Walk for 10 to 15 minutes after meals', 'Aim for 7 to 8 hours of sleep', 'A smaller waist improves insulin sensitivity. <a href="' + LINKS.waist + '">Check your waist ratio</a>, the quickest insulin-resistance clue']) +
            ctas(c, 'My HOMA-IR score is ' + homa.toFixed(2) + ' (' + name.toLowerCase() + '), from the Sugar Knocker HOMA-IR calculator.') + berb;
        }
      });
    unitToggle(root, 'unit', { glu: { mg: [40, 400, 1, 95], mmol: [2.2, 22.2, 0.1, 5.3] } }, { mg: 'mg/dL', mmol: 'mmol/L' });
  };

  /* =========================================================
     Tool 7. Lipid profile reader
     ========================================================= */
  tools.lipid = function (root) {
    frame(root, 'lipid',
      fld('Unit', seg('unit', [['mg', 'mg/dL'], ['mmol', 'mmol/L']], 'mg')) +
      '<div class="tl-grid2">' + nf('tc', 'Total cholesterol', 'mg/dL', null, { min: 50, max: 400, step: 1, def: 190 }) + nf('hdl', 'HDL cholesterol', 'mg/dL', null, { min: 10, max: 120, step: 1, def: 45 }) +
      nf('tg', 'Triglycerides', 'mg/dL', null, { min: 20, max: 800, step: 1, def: 140 }) + nf('ldl', 'LDL cholesterol', 'mg/dL', 'Leave empty and we will calculate it', { min: 10, max: 300, step: 1, def: 110, optional: true }) + '</div>' +
      '<div class="tl-grid2">' + fld('Sex', seg('sex', [['m', 'Male'], ['f', 'Female']], 'm')) + fld('Diabetes?', seg('dm', [['no', 'No'], ['yes', 'Yes']], 'no')) + '</div>',
      {
        go: 'Read my report',
        calc: function (ctx) {
          var mm = sv(root, 'unit') === 'mmol', sex = sv(root, 'sex'), dm = sv(root, 'dm') === 'yes';
          function cv(id, label, lo, hi, optional, f) { // ranges are written in mg/dL; mmol/L entries are checked at their mg/dL equivalent
            var el = q('#' + id, root), raw = el.value.trim();
            if (mm && raw !== '' && isFinite(num(raw))) {
              var v = num(raw) * f, ok = v >= lo && v <= hi, box = q('#f-' + id, root), err = q('#e-' + id, root);
              box.classList.toggle('t2-field--err', !ok);
              err.textContent = ok ? '' : label + ' should be between ' + round(lo / f, 1) + ' and ' + round(hi / f, 1) + ' mmol/L.';
              if (!ok) { ctx.bad = true; if (!ctx.first) ctx.first = el; return NaN; }
              return v;
            }
            var res = read(root, id, label, lo, hi, null, null, ctx, 'mg/dL', optional);
            return res;
          }
          var tc = cv('tc', 'Total cholesterol', 50, 600, false, 38.67), hdl = cv('hdl', 'HDL', 10, 150, false, 38.67),
              tg = cv('tg', 'Triglycerides', 20, 3000, false, 88.57), ldl = cv('ldl', 'LDL', 10, 400, true, 38.67);
          if (ctx.bad) return null;
          var calcLdl = false, ldlMsg = '';
          if (!isFinite(ldl)) {
            if (tg < 400) { ldl = tc - hdl - tg / 5; calcLdl = true; if (ldl < 0) { ldl = NaN; ldlMsg = 'LDL could not be calculated from these numbers. Ask your lab for a direct LDL.'; } }
            else ldlMsg = 'LDL can\'t be calculated when triglycerides are 400 or more. Ask your lab for a direct LDL.';
          }
          var nonhdl = tc - hdl, ratio = tg / hdl;
          function fmt(v) { return mm ? round(v / 38.67, 2) + ' mmol/L' : round(v, 0) + ' mg/dL'; }
          function fmtTg(v) { return mm ? round(v / 88.57, 2) + ' mmol/L' : round(v, 0) + ' mg/dL'; }
          function pill(kind, text) { return '<span class="t2-pill ' + kind + '">' + text + '</span>'; }
          var rows = [], out = 0, total = 0;
          function row(name, value, calc, band, kind, target) { total++; if (kind !== 'good') out++; rows.push('<tr><td>' + name + (calc ? ' <span class="t2-calc">calculated</span>' : '') + '</td><td>' + value + '</td><td>' + pill(kind, band) + '</td><td>' + target + '</td></tr>'); }
          row('Total cholesterol', fmt(tc), false, tc < 200 ? 'Desirable' : tc < 240 ? 'Borderline' : 'High', tc < 200 ? 'good' : tc < 240 ? 'warn' : 'alert', 'Under 200 mg/dL');
          if (isFinite(ldl)) {
            var lb = dm ? (ldl < 100 ? 0 : ldl < 130 ? 1 : 2) : (ldl < 100 ? 0 : ldl < 160 ? 1 : 2);
            row('LDL' + (dm ? ' (with diabetes)' : ''), fmt(ldl), calcLdl, ['Desirable', 'Borderline', 'High'][lb], ['good', 'warn', 'alert'][lb], dm ? 'Under 100 (many doctors aim under 70)' : 'Under 100 mg/dL');
          } else { rows.push('<tr><td>LDL</td><td colspan="3">' + ldlMsg + '</td></tr>'); }
          // non-HDL: diabetes bands per the spec; without diabetes the usual LDL goal + 30 mg/dL
          var nb = dm ? (nonhdl < 130 ? 0 : nonhdl < 160 ? 1 : 2) : (nonhdl < 130 ? 0 : nonhdl < 190 ? 1 : 2);
          row('Non-HDL' + (dm ? ' (with diabetes)' : ''), fmt(nonhdl), true, ['Desirable', 'Borderline', 'High'][nb], ['good', 'warn', 'alert'][nb], dm ? 'Under 130 mg/dL' : 'Under 130 mg/dL');
          var lowHdl = sex === 'm' ? hdl < 40 : hdl < 50;
          row('HDL', fmt(hdl), false, lowHdl ? 'Low' : 'Desirable', lowHdl ? 'warn' : 'good', sex === 'm' ? '40 or more (men)' : '50 or more (women)');
          var tb = tg < 150 ? 0 : tg < 200 ? 1 : tg < 500 ? 2 : 3;
          row('Triglycerides', fmtTg(tg), false, ['Desirable', 'Borderline', 'High', 'Very high'][tb], ['good', 'warn', 'alert', 'alert'][tb], 'Under 150 mg/dL');
          row('TG/HDL ratio', round(ratio, 1), true, ratio < 3 ? 'Desirable' : 'High', ratio < 3 ? 'good' : 'warn', 'Under 3');
          var banner = tg >= 500 ? urgent('Very high triglycerides need a doctor\'s review soon.') : '';
          var summary = out + ' of ' + total + ' values outside the desirable range';
          var related = '<p class="t2-fine">Related: ' + (ratio >= 3 ? '<a href="' + LINKS.homa + '">HOMA-IR calculator</a> (a TG/HDL ratio of 3 or more is often seen with insulin resistance) &middot; ' : '') + '<a href="' + LINKS.waist + '">Waist ratio calculator</a></p>';
          return banner +
            '<p class="t2-range">' + summary + '<small>' + (dm ? 'Using the tighter targets for people with diabetes' : 'Using the general adult targets') + '</small></p>' +
            '<table class="t2-table"><thead><tr><th>Measure</th><th>Your value</th><th>Band</th><th>Target</th></tr></thead><tbody>' + rows.join('') + '</tbody></table>' +
            '<p class="t2-fine">If you take a cholesterol medicine, keep taking it as prescribed.</p>' + related +
            ctas([{ k: 'consult', href: LINKS.consult, label: 'Go through your lipid report with our medical team', primary: true }],
              'I used the Sugar Knocker lipid profile reader: ' + summary + '.');
        }
      });
    var lipidRanges = {
      tc: { mg: [50, 400, 1, 190], mmol: [1.3, 10.3, 0.1, 4.9] }, hdl: { mg: [10, 120, 1, 45], mmol: [0.3, 3.1, 0.1, 1.2] },
      tg: { mg: [20, 800, 1, 140], mmol: [0.2, 9, 0.1, 1.6] }, ldl: { mg: [10, 300, 1, 110], mmol: [0.3, 7.8, 0.1, 2.8] }
    };
    unitToggle(root, 'unit', lipidRanges, { mg: 'mg/dL', mmol: 'mmol/L' });
  };

  /* =========================================================
     Tool 8. Ideal weight and 12-week target
     ========================================================= */
  tools.idealweight = function (root) {
    var r = frame(root, 'idealweight',
      '<div class="tl-grid2">' + fld('Height unit', seg('hu', [['cm', 'cm'], ['ft', 'ft and in']], 'cm')) + fld('Weight unit', seg('wu', [['kg', 'kg'], ['lb', 'lb']], 'kg')) + '</div>' +
      '<div class="tl-grid2" id="hrow">' + nf('h', 'Height', 'cm', null, { min: 120, max: 220, step: 1, def: 165 }) + '</div>' +
      '<div class="tl-grid2">' + nf('w', 'Weight', 'kg', null, { min: 30, max: 200, step: 0.5, def: 70 }) + nf('age', 'Age', 'years', null, { min: 18, max: 90, step: 1, def: 40 }) + '</div>' +
      '<div class="tl-field"><label class="t2-check"><input type="checkbox" id="preg"> I am pregnant</label></div>',
      {
        go: 'Find my healthy range',
        onReset: function () { setHeightMode('cm'); },
        calc: function (ctx) {
          var hu = sv(root, 'hu'), wu = sv(root, 'wu'), hcm, w;
          if (hu === 'ft') {
            var ft = read(root, 'hft', 'Feet', 3, 7, null, null, ctx, 'ft'), inch = read(root, 'hin', 'Inches', 0, 11.9, null, null, ctx, 'in');
            if (ctx.bad) return null;
            hcm = (ft * 12 + inch) * 2.54;
            if (hcm < 120 || hcm > 220) { var b = q('#f-hft', root); b.classList.add('t2-field--err'); q('#e-hft', root).textContent = 'Height should be between 120 cm (3 ft 11 in) and 220 cm (7 ft 3 in).'; ctx.bad = true; return null; }
          } else hcm = read(root, 'h', 'Height', 120, 220, null, null, ctx, 'cm');
          w = wu === 'lb' ? read(root, 'w', 'Weight', 66, 551, null, null, ctx, 'lb') : read(root, 'w', 'Weight', 30, 250, null, null, ctx, 'kg');
          var age = read(root, 'age', 'Age', 18, 90, null, null, ctx, 'years');
          if (ctx.bad) return null;
          var kg = wu === 'lb' ? w / 2.20462 : w, hm = hcm / 100, preg = q('#preg', root).checked;
          var bmi = kg / (hm * hm), band, kind;
          if (bmi < 18.5) { band = 'Underweight'; kind = 'warn'; } else if (bmi < 23) { band = 'Healthy'; kind = 'good'; } else if (bmi < 25) { band = 'Overweight'; kind = 'warn'; } else { band = 'Obese'; kind = 'alert'; }
          var loKg = 18.5 * hm * hm, hiKg = 22.9 * hm * hm;
          function show(k) { return wu === 'lb' ? round(k * 2.20462, 0) + ' lb' : round(k, 1) + ' kg'; }
          var consult = { k: 'consult', href: LINKS.consult, label: 'Book a free 30-minute consultation', primary: true };
          var head = '<p class="t2-range">BMI ' + round(bmi, 1) + '<small>' + band + ' on Asian cut-offs</small></p>' +
            stats([stat('Healthy range', show(loKg) + ' to ' + show(hiKg)), stat('Your BMI', round(bmi, 1), band)]);
          if (preg) return head + note('info', 'Weight targets are not for pregnancy', 'During pregnancy, weight changes are guided by your doctor. Please speak with your doctor or our medical team.') + ctas([consult]);
          if (bmi < 18.5) return head + note('warn', 'Below the healthy range', 'A BMI under 18.5 is below the healthy range. A weight-loss target is not suggested. Please speak with a doctor about healthy weight gain.') + ctas([consult]);
          if (bmi < 23) return head + note('good', 'You\'re in the healthy range', 'Aim to keep it. Regular activity and balanced meals do that best.') + ctas([consult, { k: 'tool', href: LINKS.calorie, label: 'Calorie and carb calculator' }]);
          var target = Math.max(kg * 0.95, hiKg), pace = Math.min(0.75, (kg - target) / 12), rows = [];
          for (var i = 1; i <= 12; i++) rows.push('<tr><td>Week ' + i + '</td><td>' + show(kg - pace * i) + '</td></tr>');
          var capped = (kg - target) / 12 > 0.75;
          return head + stats([stat('12-week target', show(target)), stat('Safe pace', round(pace, 2), 'kg per week')]) +
            note('info', 'A realistic first goal', 'Losing about 5% of your weight is the amount shown in diabetes-prevention research to make a difference.' + (capped ? ' We have capped the pace at 0.75 kg a week, so you may reach the target a little after week 12.' : '')) +
            '<table class="t2-table"><thead><tr><th>When</th><th>Target weight</th></tr></thead><tbody>' + rows.join('') + '</tbody></table>' +
            '<p class="t2-fine">Next: <a href="' + LINKS.calorie + '">Calorie and carb calculator</a> (choose the lose weight goal) &middot; <a href="' + LINKS.waist + '">Waist ratio calculator</a></p>' +
            ctas([{ k: 'kit', href: LINKS.kit, label: '12 weeks of diet plans and doctor check-ins', primary: true }, consult],
              'My healthy weight range is ' + show(loKg) + ' to ' + show(hiKg) + ' and my 12-week target is ' + show(target) + ', from the Sugar Knocker ideal weight calculator.');
        }
      });
    function setHeightMode(m) {
      var hr = q('#hrow', root);
      hr.innerHTML = m === 'ft' ? nf('hft', 'Height (feet)', 'ft', null, { min: 3, max: 7, step: 1, def: 5 }) + nf('hin', 'Height (inches)', 'in', null, { min: 0, max: 11, step: 1, def: 5 }) : nf('h', 'Height', 'cm', null, { min: 120, max: 220, step: 1, def: 165 });
      paintAll(hr);
    }
    bindSeg(root, 'hu', setHeightMode);
    bindSeg(root, 'wu', function (v) { q('#u-w', root).textContent = v; if (v === 'lb') setRng(root, 'w', 66, 440, 1, 154); else setRng(root, 'w', 30, 200, 0.5, 70); });
  };

  /* =========================================================
     Tool 9. eGFR (CKD-EPI 2021)
     ========================================================= */
  tools.egfr = function (root) {
    frame(root, 'egfr',
      '<div class="tl-grid2">' + nf('cr', 'Serum creatinine', 'mg/dL', 'From your blood test report', { min: 0.2, max: 6, step: 0.05, def: 1 }) + fld('Creatinine unit', seg('unit', [['mg', 'mg/dL'], ['umol', 'µmol/L']], 'mg')) + '</div>' +
      '<div class="tl-grid2">' + nf('age', 'Age', 'years', null, { min: 18, max: 110, step: 1, def: 50 }) + fld('Sex', seg('sex', [['m', 'Male'], ['f', 'Female']], 'm')) + '</div>' +
      nf('uacr', 'Urine albumin-creatinine ratio (UACR)', 'mg/g', 'If your report has it', { min: 0, max: 1000, step: 5, def: 20, optional: true }),
      {
        go: 'Calculate eGFR',
        calc: function (ctx) {
          var um = sv(root, 'unit') === 'umol', sex = sv(root, 'sex');
          var cr = um ? read(root, 'cr', 'Creatinine', 17.7, 1326, null, null, ctx, 'µmol/L') : read(root, 'cr', 'Creatinine', 0.2, 15, null, null, ctx, 'mg/dL');
          var age = read(root, 'age', 'Age', 18, 110, null, null, ctx, 'years');
          var uacr = read(root, 'uacr', 'UACR', 0, 5000, null, null, ctx, 'mg/g', true);
          if (ctx.bad) return null;
          var scr = um ? cr / 88.4 : cr, f = sex === 'f';
          var kappa = f ? 0.7 : 0.9, alpha = f ? -0.241 : -0.302;
          var egfr = 142 * Math.pow(Math.min(scr / kappa, 1), alpha) * Math.pow(Math.max(scr / kappa, 1), -1.2) * Math.pow(0.9938, age) * (f ? 1.012 : 1);
          egfr = Math.round(egfr);
          var st, nm, kind;
          if (egfr >= 90) { st = 'G1'; nm = 'Normal or high'; kind = 'good'; }
          else if (egfr >= 60) { st = 'G2'; nm = 'Mildly reduced'; kind = 'good'; }
          else if (egfr >= 45) { st = 'G3a'; nm = 'Mildly to moderately reduced'; kind = 'warn'; }
          else if (egfr >= 30) { st = 'G3b'; nm = 'Moderately to severely reduced'; kind = 'warn'; }
          else if (egfr >= 15) { st = 'G4'; nm = 'Severely reduced'; kind = 'alert'; }
          else { st = 'G5'; nm = 'Kidney failure range'; kind = 'alert'; }
          var ast = '', hasAlb = isFinite(uacr), albKind = '';
          if (hasAlb) { ast = uacr < 30 ? 'A1 (normal)' : uacr <= 300 ? 'A2 (moderately increased)' : 'A3 (severely increased)'; }
          var reduced = egfr < 60 || (hasAlb && uacr >= 30);
          var banner = egfr < 30 ? urgent('Please see your doctor or a kidney specialist soon.') : '';
          var noteSupp = reduced ? note('warn', 'Before taking any supplement', 'With reduced kidney function, check with your doctor before starting any supplement, including ours.') : '';
          var c = [{ k: 'consult', href: LINKS.consult, label: 'Book a free 30-minute consultation', primary: true }];
          if (!reduced) c.push({ k: 'tool', href: LINKS.checker, label: 'Diabetes is the commonest cause of kidney strain: check your sugar' });
          return banner +
            '<p class="t2-range">eGFR ' + egfr + ' <small>mL/min/1.73 m&sup2; &middot; stage ' + st + ' &middot; ' + nm + (hasAlb ? ' &middot; albuminuria ' + ast : '') + '</small></p>' +
            scale([[30, 'c-deep', 'G5'], [15, 'c-alert', 'G4'], [15, 'c-warn', 'G3b'], [15, 'c-warn', 'G3a'], [30, 'c-good', 'G2'], [30, 'c-good', 'G1']], posEgfr(egfr)) +
            note(kind, 'Stage ' + st + ': ' + nm, 'Creatinine is a waste product from muscle that healthy kidneys filter out. The higher it is, the lower the estimated filtering rate. Kidney disease is confirmed when results stay low for 3 months, so one test is not a diagnosis.') +
            noteSupp + ctas(c, 'My eGFR is ' + egfr + ' (stage ' + st + '), from the Sugar Knocker eGFR calculator.');
        }
      });
    unitToggle(root, 'unit', { cr: { mg: [0.2, 6, 0.05, 1], umol: [18, 530, 1, 88] } }, { mg: 'mg/dL', umol: 'µmol/L' });
  };
  function posEgfr(v) { // scale runs G5 (0) to G1 (120+); widths 30,15,15,15,30,30 map to 0-15,15-30,30-45,45-60,60-90,90-120
    var edges = [0, 15, 30, 45, 60, 90, 120], w = [30, 15, 15, 15, 30, 30];
    var segsBand = [[30], [15], [15], [15], [30], [30]];
    return bandPos(v, edges, segsBand);
  }

  /* =========================================================
     Tool 10. Blood pressure checker
     ========================================================= */
  tools.bp = function (root) {
    frame(root, 'bp',
      '<div class="tl-grid2">' + nf('sys', 'Systolic (top number)', 'mmHg', null, { min: 60, max: 260, step: 1, def: 120 }) + nf('dia', 'Diastolic (bottom number)', 'mmHg', null, { min: 30, max: 160, step: 1, def: 80 }) + '</div>' +
      nf('pulse', 'Pulse', 'bpm', null, { min: 30, max: 200, step: 1, def: 72, optional: true }) +
      '<div class="tl-grid2">' + fld('Diabetes?', seg('dm', [['no', 'No'], ['yes', 'Yes']], 'no')) + fld('On BP medicine?', seg('med', [['no', 'No'], ['yes', 'Yes']], 'no')) + '</div>',
      {
        go: 'Check my BP',
        calc: function (ctx) {
          var sys = read(root, 'sys', 'Systolic', 60, 260, null, null, ctx, 'mmHg'), dia = read(root, 'dia', 'Diastolic', 30, 160, null, null, ctx, 'mmHg');
          read(root, 'pulse', 'Pulse', 30, 200, null, null, ctx, 'bpm', true);
          if (!ctx.bad && dia >= sys) { q('#f-dia', root).classList.add('t2-field--err'); q('#e-dia', root).textContent = 'The bottom number must be lower than the top number. Check you have not swapped them.'; ctx.bad = true; if (!ctx.first) ctx.first = q('#dia', root); }
          if (ctx.bad) return null;
          var dm = sv(root, 'dm') === 'yes', med = sv(root, 'med') === 'yes';
          var si = sys < 90 ? 0 : sys < 130 ? 1 : sys < 140 ? 2 : sys < 160 ? 3 : 4;
          var di = dia < 60 ? 0 : dia < 85 ? 1 : dia < 90 ? 2 : dia < 100 ? 3 : 4;
          var idx = Math.max(si, di);
          if (idx <= 1 && Math.min(si, di) === 0) idx = 0; // low reading on either number, with neither number raised
          var names = ['Low', 'Normal', 'High-normal', 'Grade 1 hypertension', 'Grade 2 hypertension'];
          var kinds = ['warn', 'good', 'warn', 'alert', 'alert'], nm = names[idx];
          var banner = (sys >= 180 || dia >= 110) ? urgent('Rest 5 minutes and measure again. If it stays this high, or you have chest pain, breathlessness or a severe headache, seek emergency care.') : '';
          var tgt = dm ? note('info', 'Target with diabetes', 'A common target with diabetes is below 130/80. Your doctor sets yours.') : '';
          var lic = (idx >= 3 || med) ? note('warn', 'About our Herbal Tea', 'Our Herbal Tea contains licorice, which can raise blood pressure. Check with your doctor before using it.') : '';
          var text = {
            0: 'A reading under 90/60 is low. If you feel dizzy or faint, sit or lie down and speak with your doctor.',
            1: 'A reading under 130/85 is in the normal range.',
            2: 'A reading of 130-139 / 85-89 is high-normal. Salt, weight, activity and sleep matter most here.',
            3: 'A reading of 140-159 / 90-99 is in the grade 1 hypertension range.',
            4: 'A reading of 160/100 or higher is in the grade 2 hypertension range.'
          }[idx];
          return banner + '<p class="t2-range">' + nm + '<small>' + sys + '/' + dia + ' mmHg</small></p>' +
            bpChart(sys, dia) + note(kinds[idx], nm, text + ' One reading isn\'t a diagnosis: measure at home on 3 to 7 days and share the readings with your doctor.') + tgt + lic +
            '<h3 class="t2-fine" style="font-weight:800">How to measure correctly</h3>' + list(['Sit quietly for 5 minutes, back supported, feet flat, arm at heart level', 'No coffee, smoking or exercise for 30 minutes before', 'Take two readings a minute apart and note the average']) +
            ctas([{ k: 'consult', href: LINKS.consult, label: 'Book a free 30-minute consultation', primary: true }], 'My blood pressure reading is ' + sys + '/' + dia + ' (' + nm.toLowerCase() + '), from the Sugar Knocker BP checker.');
        }
      });
  };
  function bpChart(sys, dia) {
    // x = diastolic 40..120, y = systolic 80..200; zones are drawn largest first
    var W = 320, H = 230, L = 40, B = 24, T = 8, R = 8, pw = W - L - R, ph = H - T - B;
    function X(d) { return L + (Math.min(120, Math.max(40, d)) - 40) / 80 * pw; }
    function Y(s) { return T + ph - (Math.min(200, Math.max(80, s)) - 80) / 120 * ph; }
    function rect(d, s, fill) { return '<rect x="' + L + '" y="' + Y(s) + '" width="' + (X(d) - L) + '" height="' + (T + ph - Y(s)) + '" fill="' + fill + '"/>'; }
    var svg = '<svg class="t2-svg" viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Blood pressure chart: your reading of ' + sys + ' over ' + dia + ' plotted against the normal, high-normal and hypertension zones">' +
      rect(120, 200, '#F6C3BA') + rect(100, 160, '#FFE0A3') + rect(90, 140, '#FFF3C9') + rect(85, 130, '#DCE6A6') +
      '<rect x="' + L + '" y="' + Y(90) + '" width="' + pw + '" height="' + (T + ph - Y(90)) + '" fill="#64B5F6" opacity=".45"/>' +
      '<line x1="' + L + '" y1="' + (T + ph) + '" x2="' + (W - R) + '" y2="' + (T + ph) + '" stroke="#3A3637"/><line x1="' + L + '" y1="' + T + '" x2="' + L + '" y2="' + (T + ph) + '" stroke="#3A3637"/>';
    [40, 60, 80, 100, 120].forEach(function (d) { svg += '<text x="' + X(d) + '" y="' + (H - 8) + '" text-anchor="middle">' + d + '</text>'; });
    [80, 120, 160, 200].forEach(function (s) { svg += '<text x="' + (L - 6) + '" y="' + (Y(s) + 3) + '" text-anchor="end">' + s + '</text>'; });
    svg += '<text x="' + (L + pw / 2) + '" y="' + (H - 0) + '" text-anchor="middle" style="font-size:9px">Bottom number (diastolic)</text>' +
      '<circle cx="' + X(dia) + '" cy="' + Y(sys) + '" r="6" fill="#221F20" stroke="#fff" stroke-width="2"/></svg>';
    return svg + '<p class="t2-fine" style="text-align:center">Zones from the bottom left: normal, high-normal, grade 1, grade 2. Your reading is the dark dot.</p>';
  }

  /* ---------- boot ---------- */
  function boot() {
    [].forEach.call(document.querySelectorAll('[data-sk-tool2]'), function (root) {
      if (root.getAttribute('data-ready')) return;
      var name = root.getAttribute('data-sk-tool2'), fn = tools[name];
      if (!fn) return;
      root.setAttribute('data-ready', '1');
      fn(root);
      track('tool_view', name);
    });
  }
  /* any element with data-t2-cta (including the page's own consultation buttons) reports the kind of CTA tapped, nothing else */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-t2-cta]');
    if (!a) return;
    var host = document.querySelector('[data-sk-tool2]');
    track('tool_cta_click', host ? host.getAttribute('data-sk-tool2') : '', { cta: a.getAttribute('data-t2-cta') });
  }, true);
  window.SKT2 = { tools: tools, helpers: { num: num, round: round, q: q, esc: esc, note: note, urgent: urgent, stat: stat, stats: stats, list: list, nf: nf, setRng: setRng, paintAll: paintAll, bindRngs: bindRngs, fld: fld, seg: seg, bindSeg: bindSeg, sv: sv, read: read, frame: frame, ctas: ctas, fine: fine, brand: brand, printReport: printReport, scale: scale, bandPos: bandPos, track: track, LINKS: LINKS } };
  /* deferred scripts run before DOMContentLoaded, so waiting for it lets the log and food scripts register their tools first */
  if (document.readyState === 'complete') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
